
export interface NotificationsState
{
    chatsCount: number;
    shiftsCount: number;
    updatedShifts: {};
}

export const NOTIFICATIONS_FEATURE_KEY = 'notifications';
